/**
 * Translates pedagogical error categories to the selected UI language dynamically.
 * Maps variations of Portuguese and English inputs to their standardized locale keys.
 * 
 * @param category The raw category string from DB or AI (e.g. "Ortografia", "grammar", "ponctuation")
 * @param t The i18next translation function
 */
export function translateErrorCategory(category: string, t: any): string {
  if (!category) return "";
  const c = category.trim().toLowerCase();
  
  // Normalize input string to standard locale category key
  let key = "outro";
  if (c === "ortografia" || c === "orthographe" || c === "spelling") {
    key = "orthographe";
  } else if (c === "gramática" || c === "gramatica" || c === "grammaire" || c === "grammar") {
    key = "grammaire";
  } else if (c === "sintaxe" || c === "syntaxe" || c === "syntax") {
    key = "syntaxe";
  } else if (c === "naturalidade" || c === "naturalité" || c === "naturalite" || c === "naturalness" || c === "naturel") {
    key = "naturalité";
  } else if (c === "concordância" || c === "concordancia" || c === "accord" || c === "agreement") {
    key = "accord";
  } else if (c === "vocabulário" || c === "vocabulario" || c === "vocabulaire" || c === "vocabulary") {
    key = "vocabulaire";
  } else if (c === "preposição" || c === "preposições" || c === "preposicao" || c === "preposicoes" || c === "preposition" || c === "prepositions" || c.includes("préposition") || c.includes("preposi")) {
    key = "preposition";
  } else if (c === "conjugação" || c === "conjugacao" || c === "conjugaison" || c === "conjugation") {
    key = "conjugaison";
  } else if (c === "léxico" || c === "lexico" || c === "lexique" || c === "lexicon") {
    key = "lexique";
  } else if (c === "estilo" || c === "style") {
    key = "style";
  } else if (c === "ponctuation" || c === "pontuação" || c === "pontuacao" || c === "punctuation") {
    key = "ponctuation";
  } else if (c === "connecteurs" || c === "conectores" || c === "connectors") {
    key = "connecteurs";
  } else if (c === "pronoms" || c === "pronomes" || c === "pronouns") {
    key = "pronoms";
  } else if (c === "outro" || c === "outros" || c === "other" || c === "others" || c === "autre") {
    key = "outro";
  } else {
    key = c;
  }

  const translated = t(`writingErrors.categories.${key}`);
  if (translated && !translated.startsWith("writingErrors.categories.")) {
    return translated;
  }

  // Language-specific fallbacks if translations are missing or not fully loaded
  const fallbackMap: Record<string, string> = {
    orthographe: "Orthographe",
    grammaire: "Grammaire",
    syntaxe: "Syntaxe",
    naturalité: "Naturel",
    accord: "Accord",
    vocabulaire: "Vocabulaire",
    preposition: "Prépositions",
    conjugaison: "Conjugaison",
    lexique: "Lexique",
    style: "Style",
    ponctuation: "Ponctuation",
    connecteurs: "Connecteurs",
    pronoms: "Pronoms",
    outro: "Autre"
  };

  return fallbackMap[key] || category;
}
